export default __webpack_public_path__ + "static/media/logo-symbol.06438e9e.svg";